import CryptoJS from "crypto-js";

export const decryptMessage = (message: string) => {
    var iv = CryptoJS.enc.Hex.parse('e84ad660c4721ae0e84ad660c4721ae0');
    var password = CryptoJS.enc.Utf8.parse(process.env.CIPHER_PASS!);
    var salt = CryptoJS.enc.Utf8.parse(process.env.CIPHER_SALT!);
    var key128Bits1000Iterations = CryptoJS.PBKDF2(password.toString(CryptoJS.enc.Utf8), salt, { keySize: 128 / 32, iterations: 1000 });
    // @ts-ignore
    var cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(message)});
    var decrypted = CryptoJS.AES.decrypt(cipherParams, key128Bits1000Iterations, { mode: CryptoJS.mode.CBC, iv: iv, padding: CryptoJS.pad.Pkcs7 });
    return decrypted.toString(CryptoJS.enc.Utf8);
}

const KEY_STRING = 'AxcessITDeliveryApp7102';

// MD5 hash of the key string (16 bytes for AES-128)
function getKeyWordArray(): any {
  return CryptoJS.MD5(CryptoJS.enc.Utf8.parse(KEY_STRING));
}

export function symmetricEncrypt(plaintext: string): string {
  if (!plaintext) return '';
  try {
    const key = getKeyWordArray();
    const encrypted = CryptoJS.AES.encrypt(
      plaintext,
      key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return encrypted.toString(); // Base64
  } catch (err) {
    console.error(err);
    return '';
  }
}

export function symmetricDecrypt(cipherText: string): string {
  if (!cipherText) return '';
  try {
    const key = getKeyWordArray();
    const decrypted = CryptoJS.AES.decrypt(
      cipherText,
      key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return CryptoJS.enc.Utf8.stringify(decrypted);
  } catch (err) {
    console.error(err);
    return '';
  }
}